import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { InfoCircle } from "react-bootstrap-icons"

const InfoIconForKeyword = () => {
    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="region-tooltip">
                    Keywords should match your business requirements. It helps us assist you more specifically.
                </Tooltip>
            }
        >
            <span className="font-14"> <InfoCircle size={18} color="#66C15E" /></span>
        </OverlayTrigger>
    )
}

export default InfoIconForKeyword